// extracted by mini-css-extract-plugin
export default {"layout":"_49b2c8e893 c29c4ef39d _62293cce99","h_slide":"_7943bcf401","category":"_6311478787 a03292f922 _6bb371c54d"};